class AnchorScroll {
  constructor() {
    this.selectors = {
      anchorLink: '[href^="#"]:not(.js-prevent-anchor-scroll)',
    };

    this.anchorLinks = document.querySelectorAll(this.selectors.anchorLink);

    if (!this.anchorLinks.length) {
      return;
    }

    this.init();
  }

  init() {
    this.anchorLinks.forEach((link) => {
      link.addEventListener('click', (ev) => {
        const current = ev.currentTarget;
        const { hash } = current;
        if (hash) {
          ev.preventDefault();
          const target = document.querySelector(hash);
          if (target) {
            let dataOffset = 0;
            if (current.dataset.offset) dataOffset = current.dataset.offset;
            const offset = parseInt(dataOffset, 10);
            ev.preventDefault();
            window.scrollTo({
              top: target.offsetTop - offset,
              left: 0,
              behavior: 'smooth',
            });
            // force correct position
            setTimeout(() => {
              window.scrollTo({
                top: target.offsetTop - offset,
                left: 0,
                behavior: 'smooth',
              });
            }, 100);
          }
        }
      });
    });
  }
}

export default new AnchorScroll();
